<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Shipping prices (Turkey)</h4>
    </div>
    <form @submit.prevent="submitForm()">
      <v-alert type="success" :value="successAlert">
        Shipping prices updated successfully
      </v-alert>
      <v-alert type="error" :value="errorAlert">
        Please update anything
      </v-alert>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 sm12 md5 style="padding: 0px" v-for="item in itemTypes" :key="item.itemID">
            <v-flex xs12 sm12 md11 v-if="item.text !== 'others'">
              <v-text-field
                append-icon="delete"
                :append-icon-cb="() => deleteItemType(item.itemID)"
                :label="item.text + '*'"
                :error-messages="errors.collect(item.text)"
                v-validate="'required|decimal:4'"
                :data-vv-name="item.text"
                v-model.number="item.value"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md11 v-if="item.text === 'others'">
              <v-text-field
                append-icon="delete"
                :append-icon-cb="() => deleteItemType(item.itemID)"
                :label="item.text + '*'"
                :error-messages="errors.collect(item.text)"
                v-validate="'decimal:4'"
                :data-vv-name="item.text"
                v-model.number="item.value"
              ></v-text-field>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
      <v-spacer></v-spacer>
      <v-layout wrap>
        <v-flex xs12 sm12 md5>
          <v-btn type="submit" style="width: 96%; height:auto; margin-bottom: 3%" color="success"
            >Save</v-btn
          >
        </v-flex>
        <v-flex xs1 dm1 md1></v-flex>
        <v-flex xs12 sm12 md5>
          <v-btn
            @click="openAddItemTypeModal"
            style="width: 96%; height:auto; margin-bottom: 3%"
            color="primary"
            >Add type</v-btn
          >
        </v-flex>
      </v-layout>
    </form>

    <add-item-type
      :addItemTypeModal="addItemTypeModal"
      :closeAddItemTypeModal="closeAddItemTypeModal"
      :checkAlert="checkAlert"
      :addItemTypeData="addItemTypeData"
      :addItemType="addItemType"
    ></add-item-type>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import addItemType from './addItemType'

export default {
  components: {
    'add-item-type': addItemType
  },

  mounted() {
    let thePanel = document.querySelector('.panel-flat')
    thePanel.style.overflowX = 'hidden'

    this.getItemType()
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      getItemTypeUrl: 'api/get-item-type',
      updateItemTypeUrl: 'api/update-item-type',
      addItemTypeUrl: 'api/add-item-type',
      deleteItemTypeUrl: 'api/delete-item-type',
      addItemTypeModal: false,
      successAlert: false,
      errorAlert: false,
      checkAlert: false,
      itemTypeResult: [],
      itemTypes: [],
      addItemTypeData: {
        type_name: '',
        type_int_shipping_price: ''
      },
      updateShippingPriceData: {
        shippingID: [],
        shippingValue: []
      }
    }
  },

  methods: {
    deleteItemType(id) {
      swal({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .delete(this.deleteItemTypeUrl + '/' + id, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(response => {
              this.getItemType()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal('Warning', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    getItemType() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getItemTypeUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.itemTypeResult = []
          this.itemTypes = []

          this.itemTypeResult = response.data.data
          this.itemTypeResult.forEach(c => {
            this.itemTypes.push({
              text: c.type_name,
              value: c.type_int_shipping_price,
              itemID: c.item_type_id
            })
          })
        })
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          let token = localStorage.getItem('access_token')
          for (let i = 0; i < this.itemTypes.length; i++) {
            this.updateShippingPriceData.shippingID[i] = this.itemTypes[i].itemID
            this.updateShippingPriceData.shippingValue[i] = this.itemTypes[i].value
          }

          axios
            .put(this.updateItemTypeUrl, this.updateShippingPriceData, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(response => {
              this.getItemType()

              this.errorAlert = false
              this.successAlert = true
              let self = this
              setTimeout(() => {
                self.successAlert = false
              }, 2000)
            })
            .catch(() => {
              this.successAlert = false
              this.errorAlert = true
              let self = this
              setTimeout(() => {
                self.errorAlert = false
              }, 2000)
            })
        }
      })
    },

    openAddItemTypeModal() {
      this.addItemTypeModal = true
    },

    closeAddItemTypeModal() {
      this.addItemTypeModal = false
      this.checkAlert = false
      this.clearAddItemTypeData()
    },

    clearAddItemTypeData() {
      this.addItemTypeData.type_name = ''
      this.addItemTypeData.type_int_shipping_price = ''
    },

    addItemType() {
      let token = localStorage.getItem('access_token')

      axios
        .post(this.addItemTypeUrl, this.addItemTypeData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.getItemType()
          this.checkAlert = true
        })
    }
  }
}
</script>

<style>
.panel-heading {
  color: #006B8D;
  border-bottom: 2px solid #006B8D !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.dialog:not(.dialog--fullscreen) {
  max-height: 95%;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/shippingPrices.vue